// extracted by mini-css-extract-plugin
export default {"icons":"PriceCards_icons__sPFkP","greyText":"PriceCards_greyText__pM-zT"};